export interface FaqItem {
  questionKey: string;
  answerKey: string;
}

export const FAQ_ITEMS: FaqItem[] = [
  { questionKey: 'landing_faq_1_question', answerKey: 'landing_faq_1_answer' },
  { questionKey: 'landing_faq_3_question', answerKey: 'landing_faq_3_answer' },
  { questionKey: 'landing_faq_2_question', answerKey: 'landing_faq_2_answer' },
  { questionKey: 'landing_faq_6_question', answerKey: 'landing_faq_6_answer' },
  { questionKey: 'landing_faq_7_question', answerKey: 'landing_faq_7_answer' },
  { questionKey: 'landing_faq_8_question', answerKey: 'landing_faq_8_answer' },
  { questionKey: 'landing_faq_11_question', answerKey: 'landing_faq_11_answer' },
  { questionKey: 'landing_faq_10_question', answerKey: 'landing_faq_10_answer' },
  { questionKey: 'landing_faq_9_question', answerKey: 'landing_faq_9_answer' },
  { questionKey: 'landing_faq_5_question', answerKey: 'landing_faq_5_answer' },
  { questionKey: 'landing_faq_4_question', answerKey: 'landing_faq_4_answer' },
];
